import { classes } from '@src/components/layout/space';
import { SantaFace } from '@src/components/faces/SantaFace';
import './SantaAvatar.css';

export type SantaAvatarSize = 'row' | 'identity' | 'card';

export interface SantaAvatarProps {
  /**
   * row — beside a heading. identity — beside a name in an identity card.
   * card — the subject of a panel.
   */
  size?: SantaAvatarSize;
  className?: string;
}

/**
 * Shared Santa illustration, sized consistently with participant avatars.
 */
export function SantaAvatar({ size = 'row', className }: SantaAvatarProps) {
  return (
    <span className={classes('santa-avatar', size !== 'row' && `santa-avatar--${size}`, className)}>
      <SantaFace />
    </span>
  );
}
